import React, { CSSProperties } from "react";
import styled, { keyframes } from "styled-components";
import { getNewLookTokens } from "common/NewLook/tokens.ts";

interface SkeletonProps {
  width: number | string;
  height: number;
  radius?: number;
  style?: CSSProperties;
}

/** A loading placeholder in the shape of the content it stands for. */
const Skeleton = ({ width, height, radius = 6, style }: SkeletonProps) => (
  <Block
    aria-hidden={true}
    style={{ width, height, borderRadius: radius, ...style }}
  />
);

export default Skeleton;

const shimmer = keyframes`
  from { background-position: 100% 0; }
  to { background-position: -100% 0; }
`;
const Block = styled.span`
  display: block;
  background: ${(p) => {
    const tokens = getNewLookTokens(p.theme);
    return `linear-gradient(90deg, ${tokens.well} 25%, ${tokens.hairline} 50%, ${tokens.well} 75%)`;
  }};
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
